import { ElementRef, Input, Directive } from '@angular/core';
import { TableRowColor } from '../base-models/table-row-color';

@Directive({
    selector: '[rowColor]'
})
export class RowColorDirective {
    constructor(private el: ElementRef){

    }

    @Input() rowColorItem: any;
    @Input() rowColors: TableRowColor[];

    ngOnInit(){
        if(this.rowColorItem != null && this.rowColors != null && this.rowColors.length > 0){
            this.rowColors.forEach(rowColor => {
                let color = this.getColor(rowColor);
                if(color != '#ffffff'){
                    if(rowColor.Type == 'background')
                        this.el.nativeElement.style.backgroundColor = color;
                    else if(rowColor.Type == 'foreground')
                        this.el.nativeElement.style.color = color;
                }
            })
        }
    }

    private getColor(rowColor: TableRowColor){
        let color: string = '#ffffff';
        if(this.rowColorItem[rowColor.ColumnName] == null)
            return color;
        
        switch(rowColor.Condition){
            case 'greaterThan': {
                if(this.rowColorItem[rowColor.ColumnName] > rowColor.Value) {
                    color = rowColor.Color;
                    
                }
                break;
            }
            case 'lessThan': {
                if(this.rowColorItem[rowColor.ColumnName] < rowColor.Value) {
                    color = rowColor.Color;
                    
                }
                break;
            }
            case 'equals': {
                if(this.rowColorItem[rowColor.ColumnName] == rowColor.Value) {
                    color = rowColor.Color;
                    
                }
                break;
            }
        }

        return color;
    }
}